<template>
    <div>
        <div class="text-center" v-show="loadingOverlay">
            <v-progress-circular
                    :width="3"
                    color="blue"
                    indeterminate="">
            </v-progress-circular>
        </div>
        <div v-show="!loadingOverlay">
            <div v-if="noOrgMessage">

            </div>
            <div v-if="!noOrgMessage">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex md12>
                            <v-select
                                multiple
                                v-model="selectedOrganizationIds"
                                :items="availableOrganizations"
                                :deletable-chips="true"
                                :chips="true"
                                item-text="name"
                                item-value="id"
                                label="Select Organizations to Adminster">
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex md12>
                            <v-btn outlined color="success" @click="saveOrganizations()">Save</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>

        </div>
    </div>
</template>

<script>
    import api from '@/api';
    export default {
        inject : ['getProvidedUser'],
        data() {
            return {
                selectedOrganizationIds: [],
                availableOrganizations: [],
                originalOrganizationIds : [],
                organizationsActorCanAssign : [],
                organizationsCurrentlyAssignedToActor : [],
                actorUserId : null,
                loggedInUserId : null,
                noOrgMessage : false,
                loadingOverlay : false
            }
        },
        mounted() {
            this.loggedInUserId = this.$userHolder.getUserId();
            this.actorUserId = this.getProvidedUser().id;
            this.get();
        },
        methods : {
            get() {
                this.loadingOverlay = true;
                this.getOrganizationsCurrentlyAssignedToActor().then(()=> {
                    this.getOrganizationsUserCanAssign().then(() => {
                        if (this.organizationsActorCanAssign == null || this.organizationsActorCanAssign.length == 0) {
                            this.noOrgMessage = true;
                        } else {
                            this.noOrgMessage = false;
                        }

                        let selectedOrganizationIds = [], availableOrganizations= [];

                        this.organizationsCurrentlyAssignedToActor.forEach((org) => {
                            selectedOrganizationIds.push(org.id);
                            availableOrganizations.push(org);
                        });


                        this.organizationsActorCanAssign.forEach((org) => {
                            let has = false;
                            availableOrganizations.forEach((availOrg) => {
                               if (availOrg.id == org.id) {
                                   has = true;
                               }
                            });
                            if (!has) {
                                availableOrganizations.push(org);
                            }
                        });

                        this.selectedOrganizationIds = selectedOrganizationIds;
                        this.availableOrganizations = availableOrganizations;
                        this.originalOrganizationIds = JSON.parse(JSON.stringify(this.selectedOrganizationIds));
                        this.loadingOverlay = false;
                    });
                }).catch((error) => {
                    this.$root.$emit('globalError','Error Loading Organizations');
                }).finally(() => {
                    this.$root.$emit('hideGlobalOverlay');
                });
            },
            getOrganizationsUserCanAssign() {
                const loggedInUserId = this.loggedInUserId;
                return new Promise((resolve,reject) => {
                    if (this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                        api.organization.search().then((data) => {
                            let list = data.list;
                            if (list && list.length > 0) {
                                this.organizationsActorCanAssign = list.map((item) => {
                                    return {id:item.id,name:item.name};
                                });
                            } else {
                                this.organizationsActorCanAssign = [];
                            }
                            resolve();
                        }).catch(()=> {
                            reject();
                        });
                    } else {

                        api.userOrganization.search({
                            admin:true,
                            userId:loggedInUserId
                        }).then((data) => {
                            let list = data.list;
                            if (list && list.length > 0) {
                                this.organizationsActorCanAssign = list.map((item) => {
                                   return {id:item.organizationId,name:item.organizationName};
                                });
                            } else {
                                this.organizationsActorCanAssign = [];
                            }
                            resolve();
                        }).catch(()=> {
                            reject();
                        });
                    }
                });
            },
            getOrganizationsCurrentlyAssignedToActor() {
                const userId = this.actorUserId;
                const searchObj = {
                    userId: userId,
                    admin: true
                };
                return new Promise((resolve,reject) => {
                    api.userOrganization.search(searchObj).then((data) => {
                        let list = data.list;
                        if (list && list.length > 0) {
                            this.organizationsCurrentlyAssignedToActor = list.map((item) => {
                                return {id:item.organizationId,name:item.organizationName};
                            });
                        } else {
                            this.organizationsCurrentlyAssignedToActor = [];
                        }
                        resolve();
                    }).catch(error => reject(error));
                });
            },
            saveOrganizations() {
                let originalOrgs = this.originalOrganizationIds;
                let organizationIds = this.selectedOrganizationIds;
                let organizationsToDelete = [];
                let organizationsToSave = [];

                if (organizationIds.length == 0) {
                    organizationsToDelete = originalOrgs;
                } else {
                    if (originalOrgs.length > 0) {
                        originalOrgs.forEach((origOrgId) => {
                            if (!organizationIds.includes(origOrgId)) {
                                organizationsToDelete.push(origOrgId);
                            }
                        });
                    }

                    if (organizationIds.length > 0) {
                        organizationIds.forEach((orgId) => {
                           if (!originalOrgs.includes(orgId)) {
                               organizationsToSave.push(orgId);
                           }
                        });
                    }
                }

                let promises = [];

                organizationsToDelete.forEach((orgId) => {
                   promises.push(new Promise((resolve,reject) => {
                       api.userOrganization.delete(this.actorUserId,orgId).then(() => {
                           resolve();
                       },(error) => {
                           reject(error);
                       });
                   }));
                });

                organizationsToSave.forEach((orgId) => {
                    promises.push(new Promise((resolve,reject) => {
                        api.userOrganization.post({
                            admin:true,
                            primary:false,
                            userId:this.actorUserId,
                            organizationId: orgId
                        }).then(() => {
                            resolve();
                        },(error) => {
                            reject(error);
                        });
                    }));
                })

                this.$root.$emit('showGlobalOverlay');
                Promise.all(promises).then(() => {
                    this.$root.$emit("globalMessage","Organizations Saved");
                },() => {
                    this.$root.$emit("globalError","Error Saving Organizations");
                }).finally(() => {
                    this.$root.$emit('hideGlobalOverlay');
                    this.get();
                });


            }
        }
    }
</script>